import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

type FieldValues = {
  principalInterest?: number;
  propertyTaxes?: number;
  homeInsurance?: number;
  hoaDues?: number;
  pmi?: number;
  floodInsurance?: number;
}

export const calculateTotal = (
  form: FormInstance,
  key: number | string,
  {
    principalInterest,
    propertyTaxes,
    homeInsurance,
    hoaDues,
    pmi,
    floodInsurance
  }: FieldValues = {}
) => {
  const tableView = form.getFieldValue(['tableView']) || {};

  const getValueIfActive = (fieldKey: string, path: (string | number)[], overrideValue?: number) => {
    const isActive = tableView?.[fieldKey]?.active;
    const val = overrideValue ?? parseFloat(form.getFieldValue(path) ?? "0");

    return isActive ? val : 0;
  };

  const total =
    getValueIfActive('principalInterest', ['loans', key, 'principalInterest', 'value'], principalInterest) +
    getValueIfActive('propertyTaxes', ['loans', key, 'propertyTaxes', 'value'], propertyTaxes) +
    getValueIfActive('homeInsurance', ['loans', key, 'homeInsurance', 'value'], homeInsurance) +
    getValueIfActive('hoaDues', ['loans', key, 'hoaDues', 'value'], hoaDues) +
    getValueIfActive('pmi', ['loans', key, 'pmi', 'value'], pmi) +
    getValueIfActive('floodInsurance', ['loans', key, 'externalLoan', 'floodInsurance'], floodInsurance)

  return parseFloat(formatAmount(total))
};
